'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeContainerElementChildrenTypesSelector = undefined;

var _milanoteReselect = require('../../utils/milanoteReselect/milanoteReselect');

var _elementHelper = require('../../../common/elements/elementHelper');

var _elementSelector = require('../elementSelector');

// Utils
var getElementChildrenSelectionStateSlice = function getElementChildrenSelectionStateSlice(state, ownProps) {
    var elementId = ownProps.linkedElementId || ownProps.element.get('id');
    return {
        elements: (0, _elementSelector.getElements)(state),
        elementId: elementId,
        deepChildrenModificationTime: state.getIn(['cache', 'deepChildrenMod', elementId])
    };
};
var elementChildrenSelectorEqualityChecker = function elementChildrenSelectorEqualityChecker(nextStateSlice, prevStateSlice) {
    return prevStateSlice.deepChildrenModificationTime === nextStateSlice.deepChildrenModificationTime;
};
var createCustomElementChildrenSelector = (0, _milanoteReselect.createCustomEqualSelector)(elementChildrenSelectorEqualityChecker);
var makeElementChildrenSelector = function makeElementChildrenSelector() {
    return createCustomElementChildrenSelector(getElementChildrenSelectionStateSlice, function (_ref) {
        var elements = _ref.elements,
            elementId = _ref.elementId;
        return (0, _elementHelper.getChildrenDeep)(elements, elementId);
    });
};

var makeContainerElementChildrenTypesSelector = exports.makeContainerElementChildrenTypesSelector = function makeContainerElementChildrenTypesSelector() {
    return (0, _milanoteReselect.createShallowSelector)(makeElementChildrenSelector(), function (children) {
        return children.filter(function (child) {
            return (0, _elementHelper.isContent)(child) || (0, _elementHelper.isBoardLike)(child);
        }).reduce(function (acc, child) {
            var type = (0, _elementHelper.isBoardLike)(child) ? 'board' : 'card';
            var typeVal = acc[type];
            acc[type] = typeVal ? typeVal + 1 : 1;
            return acc;
        }, {});
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/containerElement/containerElementSelector.js
// module id = 725
// module chunks = 0